import { useAppNavigate } from '@crm/hooks/useAppNavigate'
import { paths } from '@crm/routes'
import { getActivePath } from '@crm/utils'
import { TitleSection } from '@shared/components'
import { useLocales } from '@shared/locales'
import { Card, Tabs } from 'antd'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import type { TabsProps } from 'antd'

const DEFAULT_MAIN_TAB_URL = '/general'

export const NomenclaturesLayout = () => {
  const { t } = useLocales()
  const { pathname } = useLocation()
  const navigate = useAppNavigate()

  const activePathname = getActivePath(pathname)

  const isActiveRootPath = Object.values(paths.admin.nomenclatures).includes(
    activePathname
  )

  const mainActiveTab = activePathname.split('/').slice(0, 3).join('/')

  const activeTab = isActiveRootPath
    ? paths.admin.nomenclatures.root
    : mainActiveTab

  if (activeTab === paths.admin.nomenclatures.root) {
    return <Navigate to={pathname + DEFAULT_MAIN_TAB_URL} />
  }

  const items: TabsProps['items'] = [
    {
      key: paths.admin.nomenclatures.general.root,
      label: t('nomenclature.general')
    },
    {
      key: paths.admin.nomenclatures.leads.root,
      label: t('lead.leads')
    },
    {
      key: paths.admin.nomenclatures.opportunities.root,
      label: t('lead.opportunities')
    },
    {
      key: paths.admin.nomenclatures.tasks.root,
      label: t('menu.tasks')
    },
    {
      key: paths.admin.nomenclatures.products.root,
      label: t('menu.products')
    }
  ]

  return (
    <>
      <TitleSection title={t('menu.nomenclatures')} />

      <Card>
        <Tabs
          activeKey={activeTab}
          items={items}
          onChange={(key) => navigate(key)}
        />

        <Outlet />
      </Card>
    </>
  )
}
